import { EmployeePreferences } from "@/interfaces/employee_type"
import { Switch } from "@/components/ui/switch"

export function DashboardLayoutOption({ preferences, availableSections, setPreference }: { 
    preferences: EmployeePreferences, 
    availableSections: string[],
    setPreference: (key: string, value: any) => void 
}) {
    const enabledSections = preferences.dashboard_layout as string[] || [...availableSections]
    
    const toggleSection = (section: string) => {
        if (enabledSections.includes(section)) {
            setPreference("dashboard_layout", enabledSections.filter((string: string) => string !== section))
        } else {
            setPreference("dashboard_layout", [...enabledSections, section])
        }
    }

    return (
        <div className="flex flex-col gap-3">
            <label className="text-lg font-medium">Dashboard Layout:</label>
            <div className="flex flex-col gap-2 pl-2">
                {availableSections.map(section => (
                    <div key={section} className="flex flex-row gap-2 items-center">
                        <Switch 
                            checked={enabledSections.includes(section)}
                            onCheckedChange={() => toggleSection(section)}
                        />
                        <label className="text-base capitalize">{section === "mini_project_list" ? "project Table" : section + "s"}</label>
                    </div>
                ))}
            </div>
        </div>
    );
}

